import { throttle } from "../utils/performance";
import { getAbsoluteElementOffsetTop } from "../utils/DOMutils";

export default function(el, activeItemClass = "toc-item--active", threshold = 4, activateFirstItem = false) {
    const tocSections = el.querySelectorAll(".toc-section");
    const tocItems = el.querySelectorAll(".toc-item");
    const secondaryTocItems = el.querySelectorAll(".toc-item--secondary");
    const signature = document.querySelector(".nav .sg-w");
    let currentActive;

    const toggleItemState = (index, items, actionType = "add") =>
        items[index] && items[index].classList[actionType](activeItemClass);

    const handleScrollEvent = throttle(() => {
        let current = activateFirstItem ? 0 : undefined;

        for (let i = tocSections.length - 1; i >= 0; i--) {
            let sectionTop = getAbsoluteElementOffsetTop(tocSections[i]);
            sectionTop -= window.innerHeight / threshold; // Activate once the element reaches the innerHeight / threshold of the screen from the top
            sectionTop -= signature ? signature.offsetHeight : 0; // Subtract signature height

            if (window.scrollY >= sectionTop) {
                current = i;
                break;
            }
        }

        if (current !== currentActive) {
            toggleItemState(currentActive, tocItems, "remove");
            secondaryTocItems && toggleItemState(currentActive, secondaryTocItems, "remove");
            currentActive = current;
            toggleItemState(current, tocItems);
            secondaryTocItems && toggleItemState(current, secondaryTocItems);
        }
    }, 100);

    if (tocSections.length === 0 || tocItems.length === 0) return;

    window.addEventListener("scroll", handleScrollEvent);
    handleScrollEvent();
}
